import { MultiSelect } from '@/components/Select'
import { Button } from '@/components/ui/button'
import { LeadDto } from 'api/Clients/Types/LeadDto'
import { FilterDescriptor } from 'store/grid/types'
import { isEmpty } from 'utils/is-empty'

export type SelectLeadModalOpenEvent = {
  filterId?: string
  value: boolean
}

const getLeadName = (lead: LeadDto): string => `${lead.firstName} ${lead.lastName}`

const getSelectedIds = (value: unknown): string[] => {
  if (value == null) return []
  const values = Array.isArray(value) ? value : [value]

  return values.map(String)
}

export const SelectLeadFilter = ({
  filter,
  onFilterChange,
  onLeadModalOpen,
}: {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
  onLeadModalOpen: (event: SelectLeadModalOpenEvent) => void
}): JSX.Element => {
  const leadsSelected = (filter?.value ?? []) as LeadDto[]
  const selectedIds = leadsSelected.map((lead) => lead.id)

  if (isEmpty(selectedIds)) {
    return (
      <Button
        size='sm'
        variant='outline'
        onClick={() => onLeadModalOpen({ filterId: filter.id, value: true })}
      >
        Choose Leads
      </Button>
    )
  }

  return (
    <MultiSelect
      className='w-full max-w-xs'
      fullWidth
      name={typeof filter.field === 'string' ? filter.field : undefined}
      options={leadsSelected.map((lead) => {
        const label = getLeadName(lead)

        return {
          key: lead.id,
          value: lead.id,
          label,
          text: label,
        }
      })}
      showDropdown={false}
      showSearch
      value={selectedIds}
      onFocus={() => onLeadModalOpen({ filterId: filter.id, value: true })}
      onChange={(value) => {
        const nextIds = getSelectedIds(value)
        const nextLeads = leadsSelected.filter((lead) => nextIds.includes(lead.id))

        onFilterChange.call(undefined, {
          nextFilter: { ...filter, filterId: filter.id, value: nextLeads },
        })
      }}
    />
  )
}
